
import { mapGetters, mapMutations } from 'vuex';
import { formatPrice } from '@/modules/Helpers';

export default {
    props: {
        categories: { type: Array, required: true },
        activeCategoryIndex: { type: Number, required: true },
        restaurant: { type: Object, required: true },
    },
    data: () => ({
        categoriesRects: [],
    }),
    computed: {
        ...mapGetters('order', ['itemsCount', 'totalPrice', 'restaurantLocation', 'groupCartSlave']),
        ...mapGetters(['loggedInUser']),
        ...mapGetters('sideDrawer', ['sideDrawerType']),
        ...mapGetters(['vat']),
        deliveryTimeIcon() {
            const icon = this.isDelivery ? 'bicycle' : 'walking';
            return icon;
        },
        deliveryTimeStr() {
            const time = this.isDelivery
                ? this.restaurantLocation?.delivery_option?.time || 0
                : this.restaurantLocation?.pickup_option?.time || 0;
            if (!time) return 'Kan ikke udregnes';
            return `${time}-${time + 5} min`;
        },
        cartString() {
            return ` <span>(${this.itemsCount} stk)</span> ${formatPrice(this.totalPrice)}`;
        },
        totalPriceFormatted() {
            return `${formatPrice(this.totalPrice)}`;
        },
    },
    watch: {
        activeCategoryIndex(index) {
            if (index === null || index < 0 || !this.categoriesRects[index]) {
                return;
            }

            const { x } = this.categoriesRects[index];
            const offset = 20;

            if (index === 0) {
                this.$refs.categoriesScroll?.scrollTo({
                    left: 0,
                    behavior: 'smooth',
                });
            } else {
                this.$refs.categoriesScroll?.scrollTo({
                    left: x - offset,
                    behavior: 'smooth',
                });
            }
        },
    },
    mounted() {
        this.getCategoriesRects();
        this.handleOrderUpdate();
    },
    activated() {
        this.handleOrderUpdate();
    },
    methods: {
        ...mapMutations('sideDrawer', ['setSideDrawer', 'closeSideDrawer']),
        ...mapMutations('modal', ['setModal']),
        handleOrderUpdate() {
            const urlSearchParams = new URLSearchParams(window.location.search);
            const params = Object.fromEntries(urlSearchParams.entries());
            if (params.updateOrder) {
                this.openCart();
            }
        },
        getCategoriesRects() {
            this.categoriesRects = [];
            if (!this.$el) return;
            const domCategories = this.$el.querySelectorAll('.category');
            if (!domCategories?.length) return;
            domCategories.forEach(x => {
                if (x) {
                    this.categoriesRects.push(x.getBoundingClientRect());
                }
            });
        },
        openCart() {
            this.setSideDrawer({ type: 'Cart' });
        },
        closeCart() {
            this.closeSideDrawer();
        },
        setGroupCartModal() {
            if (!this.loggedInUser || this.groupCartSlave) {
                return;
            }
            this.setModal({ type: 'GroupCart' });
        },
    },
};
